import * as React from 'react';
import type { CustomerDetailRecord } from '../services/customersApi';
import { customersApi } from '../services/customersApi';

export function useCustomerDetail(projectUuid: string | undefined, customerUuid: string | null) {
  const [customer, setCustomer] = React.useState<CustomerDetailRecord | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    if (!customerUuid) return null;
    setLoading(true);
    setError(null);
    try {
      const { customer: data } = await customersApi.getCustomer(projectUuid, customerUuid);
      setCustomer(data);
      return data;
    } catch (err: unknown) {
      setError((err as Error).message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [projectUuid, customerUuid]);

  React.useEffect(() => {
    void reload();
  }, [reload]);

  return { customer, loading, error, reload, setCustomer };
}
